// extracted by mini-css-extract-plugin
module.exports =  {"root":"jEe7pZVcfRFoiAHVgkQI"};